import React from 'react';
import MuiLink from '@mui/material/Link';
import type { LinkProps as NextLinkProps } from 'next/link';
import NextLink from 'next/link';

export const LinkBehavior = React.forwardRef<HTMLAnchorElement, NextLinkProps>((props, ref) => <MuiLink component={NextLink} ref={ref} {...props} />);
LinkBehavior.displayName = 'LinkBehavior';
